import { useGetPojectionByIdQuery } from '@bo-services/projectionsApi';

export const useProjectionById = ({
  projectionId
}: {
  projectionId: number | string | undefined;
}) => {
  const {
    data: response,
    isFetching,
    isError,
    isLoading,
    isSuccess
  } = useGetPojectionByIdQuery(
    { projection_id: projectionId !== undefined ? String(projectionId) : '' },
    { skip: !projectionId }
  );

  return {
    data: response,
    isFetching,
    isLoading,
    isSuccess,
    isError
  };
};
